import React, { useEffect, useRef, useState } from "react";
import "./ChatPage.css";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import MicIcon from "../../assets/voiceMic.png";
import closeIcon from "../../assets/closeIcon.png";
import CompanionLogo from "../../assets/comapionlogo.png";
import SendIcon from "../../assets/send.png";
import chatIcon from "../../assets/chaticon.png";
import StopGenerating from "../../assets/stopgeneratingicon.png";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";
import axios from "axios";
import MessageCard from "./Message";
import InitialMessageSection from "./InitialMessageSection";
import { Loader, useViewport } from "../../utils/util";
import {
  fetchArchiveChat,
  getChatConversation,
  getcodieVersions,
  getConvo,
  updateMessageLikeStatus,
} from "../../api/Service";
import { useChatContext } from "../../../../context";
import { Spinner } from "../../../web-workflow/common/Helper";
import MessageLoader from "./MessageLoader";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";
import axiosInstance from "../../../../axiosinterceptor";
import ChatVersions from "./ChatVersions";
import PromptTemplate from "./PromptTemplate";
import temperatureIcon from "../../assets/temperature.png";
import uparrowIcon from "../../assets/uparrow.png";
import downarrowIcon from "../../assets/downarrow.png";
import enlargescreenIcon from "../../assets/enlargescreen.png";
import infoIcon from "../../assets/info-circle.png";
import { toast } from "react-toastify";
import { isSymbol } from "lodash";
import { useSelector } from "react-redux";
import { resetHomepageCodieQuestion, setHomepageCodieQuestion } from "../../../HomePage/redux/HomePageSlice";
import { useDispatch } from "react-redux";

function ChatPage() {
  const messagesRef = useRef(null);
  const { common, chatAI, scroll } = useChatContext();
  const [versionID, setVersionId] = useState(6);
  const {
    conversations,
    setConversations,
    activeConversation,
    setActiveConversation,
    messages,
    setMessages,
    isFirstMesssge,
    setIsFirstMessage,
    archivedChats,
    setArchivedChats,
    isMessagesLoading,
    setIsMessagesLoading,
    noPrompts,
    setNoPrompts,
    noPromptStatus,
    setNopromptStatus,
  } = chatAI;
  const { mode } = common;
  const {
    isConversationsLoading,
    setIsConversationsLoading,
    hasMoreConversations,
    setHasMoreConversations,
    currentPage,
    setCurrentPage,
  } = scroll;
  const [isOpen, setIsOpen] = useState(false);
  const [messageInput, setMessageInput] = useState("");
  const [error, setError] = useState("");
  const [selectedModal, setSelectedModal] = useState(process.env.REACT_APP_FLAG_USA ? 6:5);
  const [stopGenerating, setStopGenerating] = useState(false);
  const [abortController, setAbortController] = useState(null);
  const [isMessageLoading, setIsMessageLoading] = useState(false);
  const [isPrevMessagesLoading, setIsPrevMessagesLoading] = useState(false);
  const [hasPrevMessages, setHasPrevMessages] = useState(true);
  const [prevMszPageNumber, setPrevMszPageNumber] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [listening, setListening] = useState(false);
  const { transcript, resetTranscript } = useSpeechRecognition("");
  const [finalTotalText, setFinalTotalText] = useState("");
  const codieInputState = useSelector((state) => state.codieStateofHomepage.homepageCodieQuestion);
  const [selectedStateBasedOpt, setselectedStateBasedOpt] = useState("None");
  const [openParameter, setOpenParameter] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showdropDownEdtions, setShowdropDownEdtions] = useState(false);
  const [showdropDowndisgonsis, setShowdropDowndisgonsis] = useState(false);
  const width = useViewport();
  const dispatch=useDispatch();
  const isMobile = width <= 600;
  const [clarificationQuestionContext, setClarificationQuestionContext] =
    useState(null);
  const [responseStatus, setResponseSatus] = useState("");
  const [codieVersionsData, setCodieVersionsData] = useState([]);
  const [initialPrompt, setInitialPrompt] = useState(null);
  const getChatParameterValues = JSON.parse(localStorage.getItem("ChatValues"));
  const [userResponseArray, setUserResponseArray] = useState([]);
  const [llmversions, setLlmVersions] = useState("");
   const [showLocationWarning, setShowLocationWarning] = useState(false);
  // const [selectedEdition, setSelectedEdition] = useState(codieEditions[0].id);
  const [selectedEdition, setSelectedEdition] = useState(1);
  const [selectedDisgonsis, setSelectedDisgonsis] = useState(1);

  const diagnosis = codieVersionsData
    .filter((item) => item.version_id === 7)
    ?.map((dis) => dis?.diagnosis);

  const codieEditions = codieVersionsData
    .filter((item) => item.version_id === 5)
    ?.map((eid) => eid?.editions);
  const [chatParameterValues, setChatParameterValues] = useState({
    temperature: getChatParameterValues?.temperature ?? 0,
    top_p: getChatParameterValues?.top_p ?? 1,
    ...(selectedModal === "VERSION_1" && {
      top_k: getChatParameterValues?.top_k ?? 250,
    }),
    max_tokens: getChatParameterValues?.max_tokens ?? 2048,
  });
  const inifinteWrapperClassName = ".chat-infinte-scroll";

  const handleMicClick = () => {
    resetTranscript("");
    setMessageInput("");
    if (!listening) {
      setIsModalOpen(true);
      setListening(true);
      resetTranscript("");
      setMessageInput("");
      SpeechRecognition.startListening();
    } else {
      setIsModalOpen(true);
      setMessageInput("");
      setListening(false);
      SpeechRecognition.stopListening();
    }
  };

  const handleOkCloseModal = () => {
    setIsModalOpen(false);
    if (listening) {
      SpeechRecognition.stopListening();
      setListening(false);
      if (transcript && transcript !== messageInput) {
        setMessageInput(transcript);
      }

      setMessageInput("");
    }
  };

  const handleCloseIcon = () => {
    setIsModalOpen(false);
    if (listening) {
      SpeechRecognition.stopListening();
      setListening(false);
    }
    resetTranscript("");
    setMessageInput("");
  };

  useEffect(() => {
    if (!listening && transcript && transcript !== messageInput) {
      setMessageInput(transcript);
      resetTranscript("");
    }
  }, [transcript, listening, messageInput]);

  const resetTransScriptPrompt = () => {
    resetTranscript("");
    SpeechRecognition.startListening();
  };

  useEffect(() => {
    if (selectedModal == 5) {
      setShowdropDownEdtions(true);
      setShowdropDowndisgonsis(false);
    } else if (selectedModal == 7) {
      setSelectedModal(7);
      setShowdropDownEdtions(false);
      setShowdropDowndisgonsis(true);
      setShowLocationWarning(true)
    } else {
      setShowdropDownEdtions(false);
      setShowdropDowndisgonsis(false);
      setShowLocationWarning(true)
    }
  }, [llmversions]);

  useEffect(() => {
    const matchingVersion = codieVersionsData.find(
      (eachVersion) => eachVersion.version_id === selectedModal
    );
    if (matchingVersion && matchingVersion.version_id !== versionID) {
      setVersionId(matchingVersion.version_id);
    }
  }, [selectedModal, versionID]);
  console.log(codieInputState,'all version id');
  const scrollToBottomFn = (prevHeight = 0) => {
    setTimeout(() => {
      const el = document.querySelector(inifinteWrapperClassName);
      if (el) {
        const { scrollHeight } = el;
        el.scrollTop = scrollHeight - prevHeight;
      }
    }, 0);
  };

  const getConversations = async (pageNum, loadMore) => {
    try {
      setIsConversationsLoading(true);
      const messages = await getConvo(pageNum);
      if (loadMore) {
        setConversations([...conversations, ...messages]);
      } else {
        setConversations(messages);
      }
      setHasMoreConversations(true);
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      return messages;
    } catch (err) {
      //console.log("get_convo_error:::", err.message);
      setHasMoreConversations(false);
      if (!loadMore) {
        setConversations([]);
      }
    } finally {
      setIsConversationsLoading(false);
    }
  };
  const getCodieVersionsData = async () => {
    try {
      const versionsData = await getcodieVersions();

      if (versionsData) {
        setCodieVersionsData([...versionsData]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getConversations(1);
    getCodieVersionsData();
  }, []);

  const handleMessageInputChange = (event) => {
    const newValue = event.target.value;

    if (newValue.length === 0) {
      setFinalTotalText("");
    }

    setMessageInput(newValue);
    dispatch(setHomepageCodieQuestion(newValue));
  };

  useEffect(() => {
    if (finalTotalText.length > 0) {
      setMessageInput(finalTotalText);
    }
  }, [finalTotalText]);

  const uploadConversationMessage = async (payload) => {
    const { conversation_id, newMessage } = payload;
    const endPoint = "/ics_llm_post_messages_ics_v1";
    axiosInstance
      .post(endPoint, {
        conversation_id,
        message_sent: newMessage.question,
        answer_received: {
          answer: newMessage.answer.answer,
          contents_list: newMessage.answer.contents_list,
        },
      })
      .then((data) => {
        //console.log("CONVO UPLOADED SUCCES::", data, messages);
        const messageRes = data.data;
        setMessages([
          ...messages,
          { ...newMessage, message_id: messageRes.prompt_id },
        ]);
        scrollToBottomFn(0);
      })
      .catch((err) => {
        console.log("CONVO UPLOAD FAIL:::", err.message);
      });
  };
  function formatConversationHistory(messages) {
    return messages
      .map((message) => {
        const answerText = message.answer
          ? message.answer.answer
          : "No answer provided";
        // Extract question and answer from each message
        return `Question: ${message.question}\nAnswer: ${answerText}`;
      })
      .join("\n\n"); // Separate each Q&A with a newline
  }
  const formattedHistory = formatConversationHistory(messages);
  // const sendMessage = (input) => {
  //   const question = input ? input : messageInput;
  //   if (!question) return;
  //   setStopGenerating(true);
  //   const controller = new AbortController();
  //   setAbortController(controller);
  //   const accessToken = sessionStorage.getItem("useremail");
  //   const newMessage = { question, response: null };
  //   setMessages([...messages, newMessage]);
  //   setIsMessageLoading(true);
  //   setMessageInput("");
  //   setFinalTotalText("");
  //   const token = sessionStorage.getItem('accessToken');
  //   // const url =
  //   //   selectedModal === "VERSION_1" ? "https://z8i4geqoui.execute-api.us-west-2.amazonaws.com/pallas-ai-gen-ai-lambda-func-v5" :
  //   //   selectedModal === "VERSION_2" ?  "https://z6c1z28z1j.execute-api.us-west-2.amazonaws.com/lambdaAWSQV2/" :
  //   //   selectedModal === "VERSION_3" ? "https://groywe42r3.execute-api.ap-southeast-2.amazonaws.com/azure_speech_text" :
  //   //   // selectedModal === "VERSION_5" ?  `${process.env.REACT_APP_BASE_API_URL}/ics_pallas-genai-v3-lambda` :
  //   //   selectedModal === "VERSION_5" ? "https://vysk8p1hl2.execute-api.ap-southeast-2.amazonaws.com/dev":
  //   //   null
  //   // const url = `${process.env.REACT_APP_BASE_API_URL}/ics_pallas-genai-v3-lambda`;
  //   // const url = "https://vysk8p1hl2.execute-api.ap-southeast-2.amazonaws.com/dev";
  //   const url = process.env.REACT_APP_FLAG_USA==='usa'?"https://vysk8p1hl2.execute-api.ap-southeast-2.amazonaws.com/dev":`${process.env.REACT_APP_BASE_API_URL}/ics_pallas-genai-v3-lambda_dev`;
  //   scrollToBottomFn(0)

  //     let payload = null
  //         if(selectedModal === "VERSION_1"){
  //             payload = { prompt: newMessage.question,
  //               temperature: getChatParameterValues?.temperature || 0,
  //               top_p : getChatParameterValues?.top_p || 1,
  //               top_k : getChatParameterValues?.top_k || 250,
  //               max_tokens : getChatParameterValues?.max_tokens || 2048
  //            }
  //         } else if(selectedModal === "VERSION_3"){
  //           payload = { prompt: newMessage.question,
  //             temperature: getChatParameterValues?.temperature || 0,
  //             top_p : getChatParameterValues?.top_p || 1,
  //             max_tokens : getChatParameterValues?.max_tokens || 2048
  //          }
  //       }else if(selectedModal==="VERSION_5"){
  //         payload={

  //             // prompt: `Provide accurate results based on this conversation history:${formattedHistory}` +
  //             //         ` User Input:${newMessage.question}`,
  //             // selectedStateBasedOpt: selectedStateBasedOpt

  //             // prompt: `Provide accurate results based on this conversation history:${formattedHistory}` +
  //             //         ` User Input:${newMessage.question}`,

  //             prompt: `${formattedHistory}` +
  //             `:${newMessage.question}`,
  //               // prompt: newMessage.question,
  //             // conversation_id:activeConversation?.conversation_id || null,
  //             selectedStateBasedOpt: selectedStateBasedOpt

  //         }
  //       }
  //         else{
  //           payload = { prompt: newMessage.question }
  //         }

  //   fetch(url, {
  //     method: "POST",
  //     headers: {
  //       'authorizationToken':`${token}`,
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({ query: newMessage.question }),
  //     body: JSON.stringify(payload),
  //     signal: controller.signal,
  //   })
  //     .then((response) => {
  //       //console.log(response, "response131::");
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       //console.log("Message sent successfully:", data);
  //       // const responseBody = JSON.parse(data.body);
  //       // console.log(responseBody, "::0909");
  //       // const message = responseBody.meesage;
  //       // newMessage.answer = message;
  //       // Check which URL was used
  //       let responseBody = data
  //       // if(url === "https://groywe42r3.execute-api.ap-southeast-2.amazonaws.com/azure_speech_text"){
  //       //   responseBody = data.body.choices[0].message
  //       // } else{

  //       //   console.log(data,"response")
  //       //   console.log(data.body,"response")
  //       //   responseBody = JSON.parse(data.body);
  //       //   console.log(responseBody,"response")
  //       // }
  //       if (
  //         url ===
  //         "https://z6c1z28z1j.execute-api.us-west-2.amazonaws.com/lambdaAWSQV2/") {

  //         const meesage = responseBody.meesage;
  //         let message = "";
  //         if (meesage) {
  //           for (const key in meesage) {
  //             if (meesage[key].answer) {
  //               message += meesage[key].answer + " ";
  //             }
  //           }
  //           message = message.trim() || "No message found";
  //         } else {
  //           message = "No message found";
  //         }
  //         newMessage.answer = {
  //           answer: responseBody.meesage,
  //         };
  //       } else if( url === "https://groywe42r3.execute-api.ap-southeast-2.amazonaws.com/azure_speech_text"){
  //         const content = responseBody.content;
  //         let message = "";
  //         if (content) {
  //           message = content.trim() || "No message found";
  //         } else {
  //           message = "No message found";
  //         }
  //         const outputContent = content.replace(/[\[\(][^\]\)]+[\]\)]/g, '')
  //         newMessage.answer = {
  //           answer: outputContent,
  //         };
  //       }else {
  //         const responseBody = data
  //         const message = responseBody.message;
  //         console.log(message,"message")
  //         newMessage.answer = {
  //           answer: message,
  //         };

  //       }
  //       console.log(newMessage,"message")
  //       newMessage.answer.contents_list = responseBody?.contents_list ? responseBody.contents_list : (responseBody.context ? responseBody.context.citations : []);
  //       if (isFirstMesssge) {
  //         getConversations()
  //           .then((data) => {
  //             //console.log("SEND_COVO::", data, newMessage);
  //             const conv = data?.find(
  //               (conv) => conv.conversation === newMessage.question
  //             );
  //             //console.log("CONV",conv,newMessage,conv.conversation,newMessage.question);
  //             if (conv.conversation_id) {
  //               setActiveConversation(conv);
  //               uploadConversationMessage({
  //                 conversation_id: conv.conversation_id,
  //                 newMessage,
  //               });
  //             }
  //           })
  //           .catch((err) => {
  //             console.log("SEND_CONV_ERR::", err.message);
  //           });
  //       } else {
  //         uploadConversationMessage({
  //           conversation_id: activeConversation.conversation_id,
  //           newMessage,
  //         });
  //       }
  //       getConversations()
  //         .then((data) => {
  //           const conv = data.find(
  //             (conv) => conv.conversation === newMessage.input
  //           );
  //           //console.log("SEND_COVO::", conv, data, newMessage);
  //         })
  //         .catch((err) => console.log("SEND_CONV_ERR::", err.message));
  //       // console.log(message, "5252::");
  //     })
  //     .catch((error) => {
  //       if(error.response && (error.response.status===401 || error.response.status===403)){
  //         let errorMessage='';
  //         if(error.response.status===401){
  //           errorMessage='Please login again'
  //         }else if(error.response.status===403){
  //           errorMessage='You do not have permission to access this resource'
  //         }
  //         window.dispatchEvent(new CustomEvent('tokenExpired', {detail:{errorMessage}}));
  //       }
  //      //console.log("There was a problem sending the message:", error);
  //       setMessages([...messages]);
  //     })
  //     .finally(() => {
  //       setIsMessageLoading(false);

  //       setStopGenerating(false);
  //     });
  //   //console.log("IS_FIRST:::", isFirstMesssge);
  //   if (isFirstMesssge) {
  //     const postpayload = {

  //         conversation: question,
  //         version_id:versionID

  //     };

  //     const postapiEndpoint =
  //       "/ics_llm_post_conversation_ics_v1";
  //     axiosInstance
  //       .post(postapiEndpoint, postpayload, { signal: controller.signal })
  //       .then((response) => {
  //         //console.log("POST request successful:", response.data);
  //         const { data } = response;
  //         if (data.errorMessage) {
  //           throw new Error(data.errorMessage);
  //         }
  //       })
  //       .catch((error) => {
  //        //console.log("Error in POST request:", error);
  //         setError(error.message);
  //       });

  //     setIsFirstMessage(false);
  //   }
  // };

  const sendMessage = (input) => {
    const question = input ? input : messageInput || codieInputState;
    if (!question || question.trim() === "") {
      toast.error("Please enter prompt");
      return;
    }

    setStopGenerating(true);
    const controller = new AbortController();
    setAbortController(controller);

    const accessToken = sessionStorage.getItem("useremail");
    const token = sessionStorage.getItem("accessToken");
    // const url = "https://cadnm6rzu8.execute-api.ap-southeast-2.amazonaws.com/ai_agent_hcs/";
    if (!initialPrompt) {
      setInitialPrompt(question);
    }
    // const url = process.env.REACT_APP_FLAG_USA==='usa'?"https://vysk8p1hl2.execute-api.ap-southeast-2.amazonaws.com/dev":`${process.env.REACT_APP_BASE_API_URL}/ics_pallas-genai-v3-lambda`;

    let url = "";
    if (selectedModal === 6) {
      url = `/ai_agent_hcs`;
    } else if (selectedModal === 7) {
      if (selectedDisgonsis === 1) {
        url = "/ics_codie_pdx_agent";
      } else if (selectedDisgonsis === 2) {
        url = "/ics_codie_adx_agent";
      } else {
        url = "/ics_codie_achi_agent";
      }
    } else if (selectedModal === 5 && process.env.REACT_APP_FLAG_USA) {
      url = "https://vysk8p1hl2.execute-api.ap-southeast-2.amazonaws.com/dev";
    } else if (selectedModal === 5) {
      // url = `/ics_pallas-genai-v3-lambda`;
      if (selectedEdition === 1) {
        url = "/ics_pallas_genai_v3_12th_edition";
      } else if (selectedEdition === 2) {
        url = "/ics_pallas-genai-v3-lambda";
      }
    }

    const newMessage = { question, response: null };

    setMessages([...messages, newMessage]);
    setIsMessageLoading(true);
    setMessageInput("");
    setFinalTotalText("");

    scrollToBottomFn(0);

    let payload = null;
    if (selectedModal == 5) {
      payload = {
        prompt: newMessage.question,
      };
    } else {
      let updatedUserResponses = [...userResponseArray];

      if (!initialPrompt) {
        setInitialPrompt(question);
      } else {
        updatedUserResponses.push(question);
        setUserResponseArray(updatedUserResponses);
      }

      payload = {
        question: initialPrompt || question,
        user_response:
          updatedUserResponses.length > 0
            ? updatedUserResponses.join("\n")
            : "",
      };
    }

    // fetch(url, {
    //   method: "POST",

    //   headers: {
    //     // Add authorization if needed:
    //     // authorizationToken: `${token}`,
    //     Authorization: `Bearer ${token}`,
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(payload),
    //   signal: controller.signal,
    // })
    //   .then((response) => {
    //     if (!response.ok) throw new Error("Network response was not ok");
    //     return response.json();
    //   })
    //   .then((data) => {
    axiosInstance
      .post(url, payload, {
        signal: controller.signal,
      })
      .then((response) => {
        const data = response.data;
        if (selectedModal === 5) {
          const responseBody = data;

          const message = data.message;
          newMessage.answer = {
            answer: message,
          };
          newMessage.answer.contents_list = responseBody?.contents_list
            ? responseBody.contents_list
            : responseBody.context
            ? responseBody.context.citations
            : [];
        } else {
          const responseBody = data;
          const message = responseBody.message || "";
          const clarificationQuestion = responseBody.clarification_question;
          setResponseSatus(responseBody.status);
          const clarificationNeeded =
            responseBody.status === "clarification_needed";
          const isComplete = responseBody.status === "complete";
          if (isComplete) {
            setUserResponseArray([]);
          }
          const log = responseBody.current_state?.log || [];
          const finalCodes = responseBody.final_codes || null;
          const confidenceScore = responseBody.confidence_score || null;
          let fullMessage = message;

          if (clarificationNeeded && clarificationQuestion) {
            fullMessage += `\n\n🔎 Clarification Needed:\n${clarificationQuestion}`;
            setClarificationQuestionContext(question);
          }

          if (isComplete && responseBody.final_codes) {
            fullMessage += `\n\n🧾 Final Code Assignment:\n${responseBody.final_codes}`;
            if (responseBody.confidence_score) {
              fullMessage += `\n\nConfidence Score: ${responseBody.confidence_score}`;
            }
          }

          newMessage.answer = {
            answer: fullMessage,
            clarification_needed: clarificationNeeded,
            clarification_question: clarificationQuestion,
            log: log,
            contents_list: responseBody?.contents_list || [],
            final_codes: finalCodes,
            confidence_score: confidenceScore,
          };
        }

        if (isFirstMesssge) {
          getConversations()
            .then((data) => {
              const conv = data?.find(
                (conv) => conv.conversation === newMessage.question
              );
              if (conv?.conversation_id) {
                setActiveConversation(conv);
                uploadConversationMessage({
                  conversation_id: conv.conversation_id,
                  newMessage,
                });
              }
            })
            .catch((err) => console.log("SEND_CONV_ERR::", err.message));
        } else {
          uploadConversationMessage({
            conversation_id: activeConversation.conversation_id,
            newMessage,
          });
        }

        getConversations()
          .then((data) => {
            const conv = data.find(
              (conv) => conv.conversation === newMessage.input
            );
          })
          .catch((err) => console.log("SEND_CONV_ERR::", err.message));
      })
      .catch((error) => {
        setInitialPrompt("");
        setUserResponseArray([]);
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          let errorMessage =
            error.response.status === 401
              ? "Please login again"
              : "You do not have permission to access this resource";
          window.dispatchEvent(
            new CustomEvent("tokenExpired", { detail: { errorMessage } })
          );
        }
        setMessages([...messages]);
      })
      .finally(() => {
        setIsMessageLoading(false);
        setStopGenerating(false);
        dispatch(resetHomepageCodieQuestion());
      });

    if (isFirstMesssge) {
      const postpayload = {
        conversation: question,
        version_id: versionID,
        child_id: showdropDownEdtions
          ? selectedEdition
          : showdropDowndisgonsis
          ? selectedDisgonsis
          : null,
      };

      const postapiEndpoint = "/ics_llm_post_conversation_ics_v1";

      axiosInstance
        .post(postapiEndpoint, postpayload, { signal: controller.signal })
        .then((response) => {
          const { data } = response;
          if (data.errorMessage) {
            throw new Error(data.errorMessage);
          }
        })
        .catch((error) => {
          setError(error.message);
        });

      setIsFirstMessage(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      sendMessage();
      dispatch(resetHomepageCodieQuestion());
    }
  };

  const handleVersionDropdown = (versionId, childId) => {
    if (versionId === 5) {
      setSelectedModal(5);
      setShowdropDowndisgonsis(false);
      setSelectedEdition(childId);
      setResponseSatus("");
      setShowLocationWarning(false);
    } else if (versionId == 7) {
      setSelectedModal(7);
      setSelectedDisgonsis(childId);
      setShowdropDownEdtions(false);
      setShowLocationWarning(true)
    } else if (versionId == 6) {
      setSelectedModal(6);
      setSelectedEdition(childId);
      setShowdropDowndisgonsis(false);
      setShowLocationWarning(true)
    }
  };

  const getConversationMessages = async (
    id,
    page_number = 1,
    isUpate = false
  ) => {
    let response;
    try {
      if (isUpate) {
        setIsPrevMessagesLoading(true);
      } else {
        setIsMessagesLoading(true);
      }
      if (id) {
        response = await getChatConversation(id, page_number);
      }
      // console.log("response::::", response);
      if (response?.error === "No prompts found") {
        setHasPrevMessages(false);
        if (!isUpate) {
          setNopromptStatus(false);
          setNoPrompts(response?.error);
          setMessages([]);
        }
        return;
      }
      const versions = response.conversations[0].version_id;
      const child_id = response.conversations[0].child_id;
      // console.log(versions,"vvvvv")
      handleVersionDropdown(versions, child_id);
      setLlmVersions(versions);
      if(response.conversations[0].version_id ==5){
        setShowLocationWarning(false)
      }else{
        setShowLocationWarning(true)
      }

      const { conversations } = response;
      if (error) {
        setHasPrevMessages(false);
        return;
      }

      if (isUpate) {
        const chats = conversations.reverse();
        setMessages([...chats, ...messages]);
        const el = document.querySelector(inifinteWrapperClassName);
        scrollToBottomFn(el.scrollHeight);
      } else {
        setMessages(conversations.reverse());
        scrollToBottomFn(0);
      }
      setHasPrevMessages(true);
      setIsFirstMessage(false);
    } catch (err) {
      setHasPrevMessages(false);
      //console.log("CONVO_MESSAGES_ERR::", err);
    } finally {
      setIsMessagesLoading(false);
      setIsPrevMessagesLoading(false);
    }
  };
  const handleConversationClick = (convo) => {
    setActiveConversation(convo);
    getConversationMessages(convo.conversation_id);
    setNopromptStatus(true);
    setShowSidebar(false);
  };
  const handleNewChatBtnClick = () => {
    if (abortController) {
      abortController.abort();
    }

    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
    setResponseSatus("");
    setInitialPrompt(null);
    setNopromptStatus(true);
    setLlmVersions("");
    setShowSidebar(false);
    setStopGenerating(false);
    setUserResponseArray([]);
    setIsMessageLoading(false);
    setAbortController(null);
  };

  const handleCoderCompanionVersion3Click = (e) => {
    console.log(e.target.value, "versions");
    const version = parseInt(e.target.value);

    if (version === 5) {
      setSelectedModal(version);
      setResponseSatus("");
      setLlmVersions("");
      setNopromptStatus(true);
      setInitialPrompt(null);
      setShowdropDownEdtions(true);
      setShowdropDowndisgonsis(false);
      setShowLocationWarning(false)
    } else if (version === 6) {
      setSelectedModal(version);
      setResponseSatus("");
      setLlmVersions("");
      setNopromptStatus(true);
      setInitialPrompt(null);
      setShowdropDownEdtions(false);
      setShowdropDowndisgonsis(false);
      setShowLocationWarning(true);
    } else if (version === 7) {
      setSelectedModal(version);
      setResponseSatus("");
      setLlmVersions("");
      setNopromptStatus(true);
      setInitialPrompt(null);
      setShowdropDownEdtions(false);
      setShowdropDowndisgonsis(true);
      setShowLocationWarning(true);
      // setShowLocationWarning(false)

    }
    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
  };

  const handleCoderCompanionGptV3Click = () => {
    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
    setSelectedModal("VERSION_3");
  };
  const handleStopGenerating = () => {
    abortController.abort();
    const newMessages = messages.filter(
      (message) => message.question !== messageInput
    );
    setMessages(newMessages);
    setStopGenerating(false);
  };
  const handleMessageClick = (title) => {
    setMessageInput(title);
    sendMessage(title);
  };

  const fetchArchivedConversations = async () => {
    try {
      const response = await fetchArchiveChat();
      setArchivedChats(response);
    } catch (err) {
      console.log("Error in Archived request:", err.message);
    }
  };
  const updateLikeState = ({
    session_token,
    message_id,
    is_liked,
    user_comment_on_message_response,
  }) => {
    updateMessageLikeStatus({
      session_token,
      message_id,
      is_liked,
      user_comment_on_message_response,
    }).then(() => {
      const updateMessages = messages.map((message) => {
        if (message.message_id === message_id) {
          return { ...message, is_liked };
        }
        return message;
      });
      setMessages(updateMessages);
    });
  };
  const getPrevMessages = () => {
    setPrevMszPageNumber((prev) => prev + 1);
    getConversationMessages(
      activeConversation.conversation_id,
      prevMszPageNumber + 1,
      true
    );
  };

  const handleParameterKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleChangeFilters = (event) => {
    setselectedStateBasedOpt(event.target.value);
  };

  const handleEditionSelection = (event) => {
    setSelectedEdition(parseInt(event.target.value));
    setIsFirstMessage(true);
    setMessages([]);
  };

  const handleDisgonsisSelection = (event) => {
    setSelectedDisgonsis(parseInt(event.target.value));
    //   setResponseSatus("")
    //   setIsFirstMessage(true);
    //   setInitialPrompt(null)
    //   setMessages([]);
    //   setLlmVersions("");
    //   console.log(llmversions,"d")
    //   console.log(responseStatus,"H")
    //    if (abortController) {
    //   abortController.abort();
    // }

    setActiveConversation({});
    setIsFirstMessage(true);
    setMessages([]);
    setResponseSatus("");
    setInitialPrompt(null);
    setNopromptStatus(true);
    setLlmVersions("");
    setShowSidebar(false);
    setStopGenerating(false);
    setUserResponseArray([]);
    setIsMessageLoading(false);
    setAbortController(null);
  };
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  const filteredVersions = codieVersionsData.filter((chatValue) => {
  if (process.env.REACT_APP_FLAG_USA) {
    return chatValue.version_id === 6;
  } else {
    return [5, 7].includes(chatValue.version_id);
  }
});

  return (
    <>
      <PromptTemplate setFinalTotalText={setFinalTotalText} />
      <div
        className={`main-page-container usa-env ${
          mode === "DARK" ? "dark-container" : " light-container"
        }`}
      >
        {mode === "DARK" && (
          <Sidebar
            conversations={conversations}
            handleClick={handleConversationClick}
            handleNewChatBtnClick={handleNewChatBtnClick}
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            getConversationsFn={getConversations}
            fetchArchivedConversations={fetchArchivedConversations}
            setMessages={setMessages}
            isLoading={isConversationsLoading}
            hasMoreConversationsVal={hasMoreConversations}
            currentPageNum={currentPage}
            versionID={versionID}
            setIsFirstMessage={setIsFirstMessage}
            setActiveConversation={setActiveConversation}
            setSelectedModal={setSelectedModal}
            showSidebar={showSidebar}
            setShowSidebar={setShowSidebar}
            setResponseSatus={setResponseSatus}
            setLlmVersions={setLlmVersions}
          />
        )}
        <div className="page-wrapper">
          <div className="chat-space-wrapper">
            <div className="coder-toggle-button">
              {/* <span
                className={selectedModal === "VERSION_1" ? "active" : ""}
                onClick={handleCoderCompanionClick}
              >
                Ai Companion V1
              </span>
              <span
                className={selectedModal === "VERSION_2" ? "active" : ""}
                onClick={handleCoderCompanionGptClick}
              >
                Ai Companion V2
              </span> */}
              {noPromptStatus && (
                <div className="chat-dropdown">
                  <div className="chat-dropdown-options">
                    <select
                    //  style={{
                    //   cursor:process.env.REACT_APP_FLAG_USA ? 'not-allowed':"pointer"
                    //  }}
                        className={`chat-select ${
    filteredVersions.length === 1 ? "no-dropdown" : ""
  }`}
                      value={selectedModal}
                      onChange={handleCoderCompanionVersion3Click}
                      disabled={process.env.REACT_APP_FLAG_USA}
                    >
                      {codieVersionsData
                        .filter((chatValue) => {
                          // Hide versions 1, 2, 3, 4
                            if (process.env.REACT_APP_FLAG_USA) {
              return chatValue.version_id === 6;
            } 
            // In non-USA: show versions 5, 6, 7 (hide 1, 2, 3, 4)
            else {
              return [5,7].includes(chatValue.version_id);
            }
                        })

                        .map((chatValue) => {
                          // console.log(chatValue, "versionData");
                          return (
                            <option
                              className="chat-option"
                              value={chatValue.version_id}
                              //  value={`VERSION_${chatValue.version_id}`}
                            >
                              {chatValue.version_name}
                              {console.log(chatValue)}
                            </option>
                          );
                        })}
                    </select>
                    {/* "chat-dropdown-options" */}
                  </div>
                  <div
                    className={
                      showdropDownEdtions ? "chat-dropdown-options" : "none"
                    }
                  >
                    {showdropDownEdtions && (
                      <select
                        className="chat-select-edition"
                        value={selectedEdition}
                        onChange={handleEditionSelection}
                      >
                        {codieEditions[0]?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.edition}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  <div
                    className={
                      showdropDowndisgonsis ? "chat-dropdown-options" : "none"
                    }
                  >
                    {showdropDowndisgonsis && (
                      <select
                        className="chat-select-edition"
                        value={selectedDisgonsis}
                        onChange={handleDisgonsisSelection}
                      >
                        {diagnosis[0]?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.diagnosis}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>
              )}
              {isMobile && (
                <button
                  className="view-conv-btn"
                  onClick={() => setShowSidebar(true)}
                >
                  Conversations
                </button>
              )}
            </div>
            <Header
              setError={setError}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              getConservations={getConversations}
              archivedChats={archivedChats}
              fetchArchivedConversations={fetchArchivedConversations}
              setOpenParameter={setOpenParameter}
            />
          </div>
          {showLocationWarning && noPromptStatus&&(
      <div className="location-warning">
        <span style={{fontWeight:"bold"}}>Notice:</span> The selected model runs via cross-region inference. Avoid sharing any sensitive data
      </div>
    )}
          {noPromptStatus ? (
            <div className="intial-message-card-wrapper">
              <div
                className={`message-wrapper ${
                  messages.length === 0 ? "initial-messages" : ""
                }`}
                ref={messagesRef}
              >
                {isMessagesLoading ? (
                  <Spinner />
                ) : (
                  <>
                    {messages.length === 0 && (
                      <InitialMessageSection
                        handleMessageClick={handleMessageClick}
                      />
                    )}

                    <InfiniteScroll
                      isTopScroll={true}
                      className="message-wrapper chat-infinte-scroll"
                      loadMore={() => getPrevMessages()}
                      hasData={hasPrevMessages}
                      isLoading={isPrevMessagesLoading}
                    >
                      {messages.map((message) => (
                        <MessageCard
                          key={message.message_id}
                          message={message}
                          sendMessage={sendMessage}
                          updateLikeState={updateLikeState}
                          responseStatus={responseStatus}
                          llmversions={llmversions}
                        />
                      ))}
                      {isMessageLoading && <MessageLoader />}
                    </InfiniteScroll>
                  </>
                )}

                {llmversions !== 7 &&
                llmversions !== 6 &&
                responseStatus !== "complete" ? (
                  <div className="search-wrapper">
                    {stopGenerating && (
                      <p
                        onClick={handleStopGenerating}
                        className="stop-generating"
                      >
                        <img src={StopGenerating} alt="CompanionLogo" />{" "}
                        <span>Stop Generating</span>
                      </p>
                    )}

                  <div>
                    <input
                      className="search-input"
                      type="text"
                      placeholder="Message AI Companion"
                      value={codieInputState && codieInputState || messageInput || finalTotalText}
                      onChange={handleMessageInputChange}
                      onKeyDown={handleKeyPress}
                    />
                  </div>
                  <div className="input-button">
                    <div className="flex-icons">
                      {selectedModal === "VERSION_3" && (
                        <div onClick={handleMicClick}>
                          <img
                            src={MicIcon}
                            alt="micicon"
                            style={{
                              height: "25px",
                              width: "25px",
                              background: "white",
                            }}
                          />
                        </div>
                      )}
                      <div onClick={() => sendMessage()}>
                        <img
                          src={SendIcon}
                          alt="sendicon"
                          style={{ height: "25px", width: "25px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <p
                  style={{
                    color: "red",
                    fontSize: "16px",
                    textAlign: "center",
                    marginTop: "10px",
                  }}
                >
                  Conversation ended. Please start a new chat to continue.
                </p>
              )}
            </div>
          </div>)
           :<p>{noPrompts}</p>} 
        </div>
      </div>
      {isModalOpen && (
        <div className="custom-chatpage-modal">
          <div className="modal-content-text">
            <div
              className="modal-flex-values"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="flex-text-and-icon">
                <img src={MicIcon} alt="micIcon" className="mic-icon" />
                <h2 className="voice-text">Voice over</h2>
              </div>
              <div>
                <img
                  src={closeIcon}
                  alt="micIcon"
                  className="close-icon"
                  onClick={handleCloseIcon}
                />
              </div>
            </div>

            {!transcript && <p>StartSpeaking...</p>}

            {transcript ? (
              <span>
                <span className="transcript-text">“ {transcript}</span>
                <span className="vertical-line">|</span>
              </span>
            ) : (
              ""
            )}
            <div className="audio-wave">
              {Array(12)
                .fill(0)
                .map((_, i) => (
                  <div
                    className="segment dot"
                    style={{ "--index": i }}
                    key={`dot-start-${i}`}
                  />
                ))}

              {Array(16)
                .fill(0)
                .map((_, i) => (
                  <div
                    className="segment wave"
                    style={{ "--index": i + 10 }}
                    key={`wave-${i}`}
                  />
                ))}

              {Array(12)
                .fill(0)
                .map((_, i) => (
                  <div
                    className="segment dot"
                    style={{ "--index": i + 28 }}
                    key={`dot-end-${i}`}
                  />
                ))}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <button className="close-btn" onClick={resetTransScriptPrompt}>
                Reset
              </button>
              <button className="close-btn" onClick={handleOkCloseModal}>
                Ok
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ChatPage;
